import * as React from "react";
import { HandleBookOfMindTurnPageRequest } from "source/app/presentation/MainPanel/Workflows/BookOfMind/Tools/TurnPageLink/Helpers/HandleBookOfMindTurnPageRequest";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import { IBookOfMindState } from "../../Helpers/IBookOfMindState";

export function TurnPageLink({
    state,
    withClass,
    linkClass,
}: {
    state: IBookOfMindState;
    withClass?: string;
    linkClass?: string;
}) {
    const shouldRefreshAllQuotes =
        state.remainingQuotesToDisplay.length <= state.numberOfQuotesToDisplay;

    if (shouldRefreshAllQuotes) {
        return null;
    }

    return (
        <IconWithText
            id="refresh"
            iconSuffix={EGlyphicon["arrow-right"]}
            whenClicked={() => HandleBookOfMindTurnPageRequest()}
            displayAsBlock={false}
            withClass={withClass}
            linkClass={linkClass}
        >
            Next page
        </IconWithText>
    );
}
